import { BentoGrid, BentoGridItem } from '@components/ui/BentoGrid';

const Grid = ({ data }: { data: any[] }) => {
  return (
    <section id="about">
      <BentoGrid className="w-full py-20">
        {data.map((item, i) => (
          <BentoGridItem
            id={item.id}
            key={i}
            title={item.title}
            description={item.des}
            className={item?.className}
            img={item.img}
            imgClassName={item.imgClassName}
            titleClassName={item.titleClassName}
            spareImg={item.spareImg}
            videoLink={item.videoLink}
          />
        ))}
      </BentoGrid>
    </section>
  );
};

export default Grid;
